import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { MsTeamsAuthorizeSchema, MsTeamsDisconnectSchema, MsTeamsStatusSchema } from '../schemas/ms-teams';
import { headers } from './meta';

const msTeamsKeys = {
	all: ['ms_teams'] as const,
	status: () => [...msTeamsKeys.all, 'status'] as const,
};

const msTeamsPaths = {
	status: () => '/ms_teams/status',
	authorize: () => '/ms_teams/authorize',
	disconnect: () => '/ms_teams/disconnect',
};

export const useMsTeamsStatus = (enabled = true) => {
	const http = useHttpClient();
	return useQuery({
		queryKey: msTeamsKeys.status(),
		queryFn: async () => {
			const res = await http.get(msTeamsPaths.status(), { headers });
			return MsTeamsStatusSchema.parse(res.data);
		},
		enabled,
	});
};

export const useMsTeamsAuthorize = () => {
	const http = useHttpClient();
	return useMutation({
		mutationFn: async (returnPath?: string) => {
			const res = await http.get(msTeamsPaths.authorize(), {
				headers,
				params: returnPath ? { return_path: returnPath } : undefined,
			});
			return MsTeamsAuthorizeSchema.parse(res.data);
		},
	});
};

export const useMsTeamsDisconnect = () => {
	const http = useHttpClient();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async () => {
			const res = await http.delete(msTeamsPaths.disconnect(), { headers });
			return MsTeamsDisconnectSchema.parse(res.data);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: msTeamsKeys.all });
		},
	});
};
